import React from "react";
import { contentTabIds } from "utils/constants";
import { ContentWell } from "./ContentWell";
import { Sidebar } from "./Sidebar";
import styles from "./TabMain.module.scss";

export const TabMain = () => (
    <div
        aria-labelledby={contentTabIds.main.tab}
        className={styles.tabMain}
        id={contentTabIds.main.panel}
        role="tabpanel"
    >
        <Sidebar />
        <ContentWell />
    </div>
);
